export type UsageBucket = {
  timestamp: string;
  value: number;
  recordCount: number;
};

export type AppUsage = {
  recordCount: number;
  totalCredits: number;
  buckets: [UsageBucket];
  app: string;
};

export type AppTotal = {
  product: string;
  totalCredits: number;
};

export type AppTotals = {
  name: string;
  totalUsage: AppTotal[];
};

export type Usage = {
  recordCount: number;
  totalCredits: number;
  appGraphData: AppUsage[];
  appProductTotals: AppTotals[];
  intervalHours: number;
};

export enum DateRange {
  DAY = "Last 24 hours",
  WEEK = "Last 7 days",
  TWO_WEEKS = "Last 14 days",
  MONTH = "Last 30 days",
  THREE_MONTHS = "Last 90 days",
}




export interface OrganisationRow {
  organisationId: string;
  apigeeDeveloperId: string;
  customerId: string;
  email: string;
  name: string;
}
